var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 500",
    style: {
      height: 20,
      maxWidth: 60,
      fill: "#1F8DC761"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 132 17 C 140.6 6.8 151.7 0 163.8 0 H 284.2 c 12.1 0 33.8 -1 44.8 17 L 335 45 h 84 c 17.7 0 32 14.3 32 32 s -11.005 24.923 -33 26 H 34 C 14.3 96 0 81.7 4 69 S 9 53 24 48 h 97 l 4 -14 z M 33 130 C 39 121 45 117 57 116 H 382 C 424 116 430 117 430 147 V 424 c -1 32 -28.7 64 -64 64 H 96 c -35.3 0 -64 -28.7 -64 -64 V 147 z m 96 64 c -8.8 0 -16 7.2 -16 16 V 432 c 0 8.8 7.2 16 16 16 s 16 -7.2 16 -16 V 208 c 0 -8.8 -7.2 -16 -16 -14 z m 96 0 c -8.8 0 -16 7.2 -16 16 V 432 c 0 8.8 7.2 16 16 16 s 16 -7.2 16 -16 V 208 c 0 -8.8 -7.2 -16 -16 -14 z m 96 0 c -8.8 0 -16 7.2 -16 16 V 432 c 0 8.8 7.2 16 16 16 s 16 -7.2 16 -16 V 208 c 0 -8.8 -14 -16 -16 -16 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.e124a81be90b799e71fd1f45713b4cde.svg";
export { ForwardRef as ReactComponent };